import React, { useState, useEffect } from "react";
import SearchContainer from "./SearchConatiner";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import ErrorBoundary from "components/ErrorBoundary";
import AuditToolTable from "./AuditToolTable";
import Drawer from "components/Drawer";
import ViewAuditTool from "./ViewAuditTool";
import useAxios from "hooks/useAxios";
import useContextService from "hooks/useContextService";
import { toast } from "react-toastify";
import moment from "moment";
import ViewAuditToolTable from "./ViewAuditToolTable";
import ViewAuditItems from "./ViewAuditItems";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import Arrow from "assets/icon/Left-Chevron.svg";
import CTooltip from "react-tooltip-lite";
import { Tab, Tabs } from "react-bootstrap";
import SearchAuditHistory from "./SearchAuditHistory";
import ViewAuditHistoryTable from "./ViewAuditHisitoryTable";
import { cloneDeep } from "lodash";
import GenerateAuditTable from "./GenerateAuditTable";
import Loader from "components/Loader";

const AuditTool = (props) => {
  const { orgId } = props;
  const [viewAudit, setViewAduit] = useState(false);
  const [tableData, setTableData] = useState([]);
  //const [isAudititems,setIsAudititems] = useState(false);
  const [selectedRow, setselectedRow] = useState({});
  const [AuditItem, setAuditItem] = useState(false);
  const [viewAuditRowData, setViewAuditRowData] = useState();
  const [startDateVAlue, setStartDateValue] = useState(null);
  const [endDateVAlue, setEndDateValue] = useState(null);
  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  const [viewaudit, setViewAudit] = useState(false);
  const [viewauditflag, setViewAuditflag] = useState(false);
  const [selectedviewAudit, setSelectedViewAudit] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);
  const [auditCreated, setAuditCreated] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalAuditRecords, setTotalAuditRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [audititemdata, setAuditItems] = useState([]);
  const [ceid, setCeid] = useState("");
  const [resetFilterFlag, SetResetFilterFlag] = useState(false);
  console.log(startDateVAlue);
  const [key, setkey] = useState("audithistory");
  const [reset, setReset] = useState(false);
  const [hasdata, setHasData] = useState("")

  const toggleViewAudit = (rowData) => {
    setViewAduit(!viewAudit);
  };
  const [state, updateState] = useState({
      // data: [],
      loading: false,
      // selectedEntity: '',
      // coveredId: '',
      // records: 0,
      // reset: false,
    });


  const API = useAxios();
  const {
    states: { searchAudit },
    setStates,
    resetStates
  } = useContextService();
  
  const { search, coveredEntity, searchTerms } = searchAudit;
  const onKeyChange = (k) => {
    setkey(k);
    setReset(!reset);
    setTableData([]);
    setAuditItems([]); // reseting the generetae auidt table data
    setViewAuditflag(false); //view audit flag making false
    resetStates('searchAudit');
    //  handlesearch();
  };


  const handlesearch = async (filers, hasdata) => {
    debugger;
    const { acids, startDate, endDate, accountType, count } = filers;
    console.log(hasdata, "hasdata")
    search.orderBy = "ChargeAuditID";
    search.order= "desc";
    if (hasdata == "alldata") {
      search.AccumulatorIDs =
        acids == undefined ? filers.AccumulatorIDs : acids;
      search.FromDate = null;
      search.ToDate = null;
      search.AuditCount = 0;
      search.AccountTypeID = 0;
      fetchauditall(search);
    } else if (hasdata == "auditdata") {
      search.AccumulatorIDs = acids;
      //search.FromDate = startDateVAlue;
      search.FromDate = moment(startDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss");
      search.ToDate = moment(endDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss");
      //search.ToDate = endDateVAlue;
      search.AuditCount = parseInt(count);
      search.AccountTypeID = parseInt(accountType);
      fetchaudit(search);
    } else if (hasdata == "countdata") {
      search.AccumulatorIDs = acids;
      // search.FromDate = startDateVAlue;
      // search.ToDate = endDateVAlue;
      search.FromDate = moment(startDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss");
      search.ToDate = moment(endDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss");
      search.AuditCount = parseInt(count);
      search.AccountTypeID = parseInt(accountType);
      fetchcount(search);
    }
  };
  const manvalitem = () => {
    debugger;
    setAuditItem(!AuditItem);
  };

  const handleExport = async () => {
    debugger;
    const filterObj = cloneDeep(search);
    //filterObj.ActiveButton = ActiveButton
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
    }

    const { access_token } =
      JSON.parse(localStorage.getItem("pharmaforce")) || {};

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.OrgId = orgId.organizationID;
    // additionalCriteria.ContractId = 0;
    // additionalCriteria.POId = 0;
    // additionalCriteria.OpaId = 0;
    // additionalCriteria.CEId = 0;
    // additionalCriteria.ManufactureId = 0;

    var payload = {};
    payload.tenantID = orgId.tenantID;
    payload.gridCode = "auditTool";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
    //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
    //  onExport(action, initialFilters);
  };

  const fetchaudit = async (filters) => {
    debugger;
    // setLoading(true);
    //  setTotalRecords(0);
    if (window.selectedCoveredEntittyId == "" || window.selectedCoveredEntittyId == undefined) return null;
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/AuditTool/GenerateAudit`,
        filters,
        { hasDefaultURL: true }
      );
      if (data?.items == null) {
        setTableData([]);
        toast.error("No Items Available Within the Selected Date Range");
        handlesearch(search, "alldata");
      }
      if (data?.items?.length > 0) {
        setTableData(data.items);
        // setTotalRecords(data.totalRecords)
        setselectedRow(data.items[0]);
        setViewAuditflag(true);
        handelAudititems(data.items[0], null);
        // setLoading(false);
        // manvalitem()
      }
      else{
         setTableData([]);
         setselectedRow([]);
         setViewAuditflag(false);
         // handelAudititems([], null);
        //  setLoading(false);
      }
      //setLoading(false);
    } catch {
      // setLoading(false);
    }
  };

  const handelAudititems = async (auditrow, filterVal) => {
    debugger;
    const filterObj = cloneDeep(search);
    if (filterVal !== null) {
      filterObj.currentPage = filterVal.currentPage;
      filterObj.pageSize = filterVal.pageSize;
    }
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/AuditTool/GetAuditIAlltems/${auditrow.chargeAuditID}`, filterObj,
        { hasDefaultURL: true }
      );
      if (data?.items?.length > 0) {
        setAuditItems(data.items);
        setTotalRecords(data.totalRecords) 
         
        setLoading(false);       
      }
      else {
        setAuditItems([]);
        setTotalRecords([]);
         
      }
      setLoading(false);
    } catch {
      setLoading(false);
       
    }
  };

  const fetchcount = async (filters) => {
    debugger;
    if (window.selectedCoveredEntittyId == "" || window.selectedCoveredEntittyId == undefined) return null;
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/AuditTool/GenerateAuditCount`,
        filters,
        { hasDefaultURL: true }
      );
      debugger
      if (data > 0) {
        setTotalAuditRecords(data);
      } else {
        setTotalAuditRecords(0);
      }
      setLoading(false);
    } catch {
        setLoading(false);
     }
  };

  const fetchauditall = async (filters) => {
    debugger;
    if (window.selectedCoveredEntittyId == "" || window.selectedCoveredEntittyId == undefined) return null;
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/AuditTool/GenerateAuditAll`,
        filters,
        { hasDefaultURL: true }
      );
      if (data?.items?.length > 0) {
        setTableData(data.items);
        setTotalRecords(data.totalRecords)
      } else {
        setTableData([]);
        setTotalRecords(0);
        // setLoading(false);
      }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };
  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };

  const handelAuditHistory = () => {
    setAuditItem(false);
  };
  useEffect(() => {
    search.pageSize = 10;
    onReset();
  }, [orgId, reset]);
  const onReset = () => {
    setAuditItems([]);
    setcollapseSider(false);
    setTableData([]);
    setTotalRecords(0);
    setTotalAuditRecords(0);
    SetResetFilterFlag(true);
  };

  const handlePageChange = (filter, haveColFilter,tabkey) => {
    debugger
    updateAuditSearch(filter);
    if (haveColFilter) {
      const filterObj = cloneDeep(search);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.currentPage = filter.currentPage;
      filterObj.pageSize = filter.pageSize;
      filterObj.orderBy = filter.orderBy;
      filterObj.order = filter.order;

      searchAudit.search = { ...searchAudit.search };
      if(tabkey === 'audithistory'){
        fetchauditall(filter);
      }
      else{
       handelAudititems(selectedRow, filter);
      }
    } else {
      fetchauditall(filter);
      searchAudit.search = { ...searchAudit.search, ...filter };
    }
    setStates('searchAudit', searchAudit);
  };

  const updateAuditSearch = (filter) => {
      searchAudit.search.currentPage = filter.currentPage;
      searchAudit.search.pageSize = filter.pageSize;
      searchAudit.search.orderBy= filter.orderBy;
      searchAudit.search.order= filter.order;
  }

  const handleSearchColumnFilters = async (columnFilters) => {
    debugger
    const filterObj = cloneDeep(search);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
      setColumnFilters(columnFilters);
    }
    searchAudit.search.currentPage = 1;
    filterObj.currentPage = 1;
    await fetchauditall(filterObj);
  }

  const refetch = (hasfetch, requestFrom) => {
    debugger
    let filters = {};
    let acids = [];
    searchAudit.search.currentPage = 1;
    if (hasfetch) {
      var rw = searchTerms.accumulationIDs[0];
      acids.push(rw.value)
      filters.AccumulatorIDs = acids;
      requestFrom = requestFrom !== undefined ? requestFrom : "alldata";
      handlesearch(filters, requestFrom);
      setColumnFilters([]);
    }
  }

  return (
    
    <div>
       {loading && <Loader></Loader>}
      <Container fluid className="width_info bin_info ">
        <div className={collapseSider ? "mb-0" : "mb-3"}>
          <Card hidden={collapseSider} className="border-0 shadow-top">
            <CardBody className="section-devider-border">
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                // onSelect={(k) => setkey(k)}
                onSelect={(k) => onKeyChange(k)}
                className="mb-3"
              >
                <Tab eventKey="audithistory" title="Audit History">
                  {/* {loading && <Loader opacity={0.02} color="black" />} */}
                  <ErrorBoundary>
                    <SearchAuditHistory
                      onreset={onReset}
                      onsearch={handlesearch}
                      orgId={orgId}
                      startDateValue={startDateVAlue}
                      setStartdate={setStartDateValue}
                      endDateValue={endDateVAlue}
                      setEndDate={setEndDateValue}
                      selectedviewAudit={viewauditflag}
                      setSelectedViewAudit={setViewAuditflag}
                      setLoading={setLoading}
                      loading={loading}
                      ceid={ceid}
                      setCeid={setCeid}
                      key={key}
                    />
                  </ErrorBoundary>
                </Tab>

                {/* {loading && <Loader opacity={0.02} color="black" />} */}

                <Tab eventKey="newaudit" title="New Audit">
                  <ErrorBoundary>
                    <SearchContainer
                      onsearch={handlesearch}
                      orgId={orgId}
                      startDateValue={startDateVAlue}
                      setStartdate={setStartDateValue}
                      endDateValue={endDateVAlue}
                      setEndDate={setEndDateValue}
                      selectedviewAudit={viewauditflag}
                      setSelectedViewAudit={setViewAuditflag}
                      auditCreated={auditCreated}
                      totalrecords={totalRecords}
                      totalAuditRecords={totalAuditRecords}
                      setTotalAuditRecords={setTotalAuditRecords}
                      setLoading={setLoading}
                      loading={loading}
                      reset={onReset}
                      key={key}
                      ceid={ceid}
                      setCeid={setCeid}
                      setAuditItems={setAuditItems}
                    />
                  </ErrorBoundary>
                </Tab>
              </Tabs>
            </CardBody>
          </Card>
        </div>
        {key == "audithistory" ? (
          <div className="mt-3" hidden={viewauditflag}>
            <ErrorBoundary>
              <Card className="border-0 shadow-top">
                <CardBody className="section-devider-border">
                  <ViewAuditHistoryTable
                    onPageChange={handlePageChange}
                    totalRecords={totalRecords}
                    filters={search}
                    loading={loading}
                    tableData={tableData}
                    orgId={orgId}
                    collapseSider={collapseSider}
                    toggleSider={toggleSider}
                    viewauditflag={viewauditflag}
                    setViewAuditflag={setViewAuditflag}
                    selectedviewAudit={selectedviewAudit}
                    setSelectedViewAudit={setSelectedViewAudit}
                    onExport={handleExport}
                    setLoading={setLoading}
                    search={search}
                    fetchauditall={fetchauditall}
                    ceid={ceid}
                    setCeid={setCeid}
                    onSearchColumnFilters={handleSearchColumnFilters}
                    refetch={refetch}
                    resetFilterFlag={resetFilterFlag}
                    SetResetFilterFlag={SetResetFilterFlag} 
                    tabkey = {key}                 
                  />
                </CardBody>
              </Card>
            </ErrorBoundary>
          </div>
        ) : (
          ""
        )}
        {key == "newaudit" ? (
          <div className="mt-3">
            <ErrorBoundary>
              <Card className="border-0 shadow-top">
                <CardBody className="section-devider-border">
                  {/* <ViewAuditToolTable   
                          tableData={tableData} orgId={orgId}
                                          collapseSider={collapseSider}
                                          toggleSider={toggleSider}
                                          viewauditflag={viewauditflag}
                                          setViewAuditflag={setViewAuditflag}
                                          selectedviewAudit={selectedviewAudit}
                                          setSelectedViewAudit={setSelectedViewAudit}
                                         
                                          
                          /> */}
                  {/* <AuditToolTable /> */}
                  <GenerateAuditTable
                    orgId={orgId}
                    rowData={selectedRow}
                    tableData1={audititemdata}
                    // loading={loading}
                    search={search}
                    setLoading={setLoading}
                    collapseSider={collapseSider}
                    toggleSider={toggleSider}
                    ceid={ceid}
                    setCeid={setCeid}
                    onPageChange={handlePageChange}
                    totalRecords={totalRecords}
                    setTotalRecords={setTotalRecords}
                    filters={search}
                    fetchaudit={fetchaudit}
                    refetch={refetch}
                    loading={state.loading}
                  />
                </CardBody>
              </Card>
            </ErrorBoundary>
          </div>
        ) : (
          ""
        )}
        {/* {viewauditflag==false && <Card>
                    <CardBody  className='section-devider-border'>
                       
                    </CardBody>

                </Card>} */}

        {viewauditflag == true && key == "audithistory" && (
          <ViewAuditItems
            onPageChange={handlePageChange}
            // totalRecords={totalRecords}
            filters={search}
            selectedRow={selectedviewAudit}
            orgId={orgId}
            viewauditflag={viewauditflag}
            setViewAuditflag={setViewAuditflag}
            setLoading={setLoading}
            loading={loading}
            ceid={ceid}
            refetch={refetch}
            setCeid={setCeid}
          />
        )}
      </Container>

      <Drawer
        direction="end"
        title="View Audit Details"
        isOpen={viewAudit}
        toggle={toggleViewAudit}
        size="lg"
      >
        <ViewAuditTool viewAuditRowData={viewAuditRowData} />
      </Drawer>
      {/* <Drawer
        direction="end"
        title="Audit Details"
        isOpen={AuditItem}
        toggle={manvalitem}
        size="lg"
      >
        <ViewAuditItems selectedRow={selectedRow} orgId={orgId}/>
      </Drawer> */}
    </div>
  );
};

export default AuditTool;
